import React from 'react';
import Login from './Login';
import Register from './Register';

/**
 * Pestañas + formulario de autenticación. Es la ÚNICA implementación del
 * login/registro: la usan tanto el modal del navbar (AuthModal) como la
 * página /login (LoginPage), para que ambas ofrezcan siempre lo mismo —
 * incluido el acceso con Google.
 *
 * No pinta tarjeta ni fondo: eso lo aporta el contenedor (modal o página).
 */
const AuthPanel = ({ mode, onModeChange, onSuccess, onDismiss }) => {
  const tabClass = active =>
    `flex-1 py-3 px-4 text-center font-medium transition-colors ${
      active
        ? 'text-df-accent-hover border-b-2 border-df-accent'
        : 'text-df-muted hover:text-df-text border-b-2 border-transparent'
    }`;

  return (
    <>
      <div className="flex border-b border-df-border">
        <button
          type="button"
          className={tabClass(mode === 'login')}
          onClick={() => onModeChange('login')}
        >
          Iniciar Sesión
        </button>
        <button
          type="button"
          className={tabClass(mode === 'register')}
          onClick={() => onModeChange('register')}
        >
          Registrarse
        </button>
      </div>

      <div className="p-6">
        {mode === 'login' ? (
          <Login
            onSuccess={onSuccess}
            onDismiss={onDismiss}
            onSwitchToRegister={() => onModeChange('register')}
          />
        ) : (
          <Register onSuccess={onSuccess} onSwitchToLogin={() => onModeChange('login')} />
        )}
      </div>
    </>
  );
};

export default AuthPanel;
